import {
  computed,
  onMounted,
  onUnmounted,
  shallowRef,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import useMyOrder from 'hooks/useMyOrder';
import useMyOrders from 'hooks/useMyOrders';
import basic from './ct/useCustomerTools';
import {
  loginToken,
  logout as lo,
} from '../src/apollo/auth';
import { cache } from '@/apollo';
import { CUSTOMER } from '@/constants';
import { createReactive } from './lib';
const saveCustomerState = (c) => {
  customerGlobal.setValue(c);
};
const createResetToken = basic.createResetToken;
const updateUser = ({ firstName, lastName, email }) =>
  basic
    .updateUser({
      version: customerGlobal.ref.value.version,
      firstName,
      lastName,
      email,
    })
    .then((result) => {
      saveCustomerState(result.data.updateMyCustomer);
    });
const li = (email, password) =>
  basic
    .login(email, password)
    .then((data) => {
      return loginToken(email, password).then(() => data);
    })
    .then((result) => {
      saveCustomerState(
        result.data.customerSignMeIn.customer
      );
      //reset entire cache, customer may have specific prices
      cache.reset();
      return result;
    });
const customerGlobal = createReactive(
  JSON.parse(localStorage.getItem(CUSTOMER)),
  (newValue) =>
    localStorage.setItem(CUSTOMER, JSON.stringify(newValue))
);
function useCustomerTools() {
  const customer = shallowRef(customerGlobal.ref.value);
  const unListen = { fn: () => 88 };
  onMounted(() => {
    unListen.fn = customerGlobal.addListener((newValue) => {
      customer.value = newValue;
    });
  });
  onUnmounted(() => unListen.fn());
  const router = useRouter();
  const route = useRoute();
  const showLoggedIn = computed(() => {
    return Boolean(customer.value);
  });
  const signup = (form) =>
    basic
      .signup(form)
      .then((data) => {
        return loginToken(form.email, form.password).then(
          () => data
        );
      })
      .then((result) => {
        saveCustomerState(
          result.data.customerSignMeUp.customer
        );
        //reset entire cache, customer may have specific prices
        cache.reset();
        router.push({ name: 'user' });
        return result;
      });
  const resetPassword = ({ token, newPassword }) =>
    basic.resetPassword({ token, newPassword }).then(() =>
      router.push({
        name: 'login',
      })
    );

  const logout = () => {
    lo();
    customerGlobal.setValue(null);
    //reset entire cache, customer may have had specific prices
    cache.reset();
    router.push({ name: 'login' });
  };
  const login = (email, password) =>
    li(email, password).then(() =>
      router.push({ name: 'user' })
    );
  const returnItems = (id, version, items) => {
    return basic
      .returnItems(id, version, items)
      .then(() => {
        cache.evict({ id: 'orders' });
        cache.gc();
        router.push({
          name: 'order',
          params: { id },
        });
      });
  };
  const updateMyCustomerPassword = ({
    currentPassword,
    newPassword,
  }) =>
    basic
      .updateMyCustomerPassword({
        currentPassword,
        newPassword,
        version: customerGlobal.ref.value.version,
      })
      .then((result) => {
        const c = result.data.customerChangeMyPassword;
        saveCustomerState(c);
        return loginToken(c.email, newPassword);
      })
      .then(() => router.push({ name: 'user' }));
  const gotoResetToken = (token) =>
    router.push({
      name: 'reset-password',
      params: { token },
    });
  const customerCreatePet = (form) => {
    return basic.createPetForUser(form)
      // One could also directly send the user to the pet page, but cache is slow
      // .then((response) => {
      //         console.log(response)
      //         router.push({path: `/DE/en/product/${response.data.createProduct.skus}/${response.data.createProduct.skus}`})
      //       });
      .then(() => router.push({name: 'pets'}));
  }

  const { token } = route?.params || {};
  return {
    token,
    login,
    signup,
    showLoggedIn,
    customer,
    updateUser,
    logout,
    createResetToken,
    resetPassword,
    useMyOrders,
    useMyOrder,
    returnItems,
    gotoResetToken,
    updateMyCustomerPassword,
    customerCreatePet,
  };
}
export default useCustomerTools;
